import { QueryClient } from '@tanstack/react-query';
import { ApiClientError } from './client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (count, error) => {
        if (error instanceof ApiClientError) {
          if ([400, 401, 403, 404, 409].includes(error.status)) return false;
          return error.error.retryable && count < 2;
        }
        return count < 1;
      },
    },
    mutations: { retry: false },
  },
});
